import {
  Grid,
  Typography,
  Checkbox,
  Box,
  FormControlLabel,
} from "@mui/material";
import InputControlled from "components/Controllers/Input";
import AutocompleteControlled from "components/Controllers/Autocomplete";
import CheckboxControlled from "components/Controllers/Checkbox";
import { Controller } from "react-hook-form";
import { useState } from "react";

const UserInfo = ({
  control,
  documents,
  setSamePersonPay,
  inputValue,
  disableInputs,
  setDisableInputs,
  setInputValue,
}) => {
  const [localInputValue, setLocalInputValue] = useState(inputValue);
  const [focus, setFocus] = useState(false)

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Typography variant="title" color="primary">
          Información
        </Typography>
      </Grid>

      <Grid item xs={12}>
        <Grid container spacing={2}>
          <Grid item xs={12} md={6}>
            <AutocompleteControlled
              label="Tipo de Documento"
              name="customer_document_type"
              control={control}
              rules={{ required: true }}
              options={documents}
              defaultValue=""
              disabled={true}
              inputValue={!focus ? inputValue : localInputValue}
              onFocus={() => setFocus(true)}
              onInputChange={(_, newInputValue) => {
                if (inputValue && !disableInputs && newInputValue !== "") {
                  setInputValue(newInputValue);
                  setLocalInputValue(newInputValue);
                }
              }}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <InputControlled
              label="N° Documento"
              name="customer_document_number"
              control={control}
              rules={{ required: true }}
              inputProps={{ maxLength: 15 }}
              disabled={true}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <InputControlled
              label="Nombres"
              name="customer_firstname"
              control={control}
              rules={{ required: true }}
              inputProps={{ maxLength: 30 }}
              disabled={disableInputs}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <InputControlled
              label="Apellidos"
              name="customer_lastname"
              control={control}
              rules={{ required: true }}
              inputProps={{ maxLength: 30 }}
              disabled={disableInputs}
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <InputControlled
              label="Correo"
              name="customer_email"
              control={control}
              rules={{ required: true }}
              inputProps={{ maxLength: 30 }}
              type="email"
              disabled={disableInputs}
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <InputControlled
              label="Número Celular"
              name="customer_number_phone"
              control={control}
              rules={{ required: true }}
              inputProps={{ maxLength: 30 }}
              disabled={disableInputs}
            />
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={8}>
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <FormControlLabel
            label="¿La información es la misma para la compra?"
            control={
              <Checkbox
                variant="caption"
                defaultChecked
                onChange={(e) => setSamePersonPay(e.target.checked)}
              />
            }
          />
        </Box>
      </Grid>
      <Grid item xs={4}>
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <FormControlLabel
            label="Editar información"
            control={
              <Checkbox
                variant="caption"
                value={!disableInputs}
                onChange={(e) => setDisableInputs(!e.target.checked)}
              />
            }
          />
        </Box>
      </Grid>
    </Grid>
  );
};

export default UserInfo;
